























// @ts-ignore
import TrackeData from '@/utils/trackData';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class BanshuBtn extends Vue {
[x: string]: any;

  @Prop() lessonInfo!: any

  @Prop() currentClass!: any

  @Prop() userInfo: any

  @Prop() currentTime!: number

  private href: string = window.location.href

  // 是否签约
  get unSigned(): boolean|0 {
    return !this.userInfo.signed;
  }

  // 点击埋点
  private clickTrack(action: string, params: any) {
    this.$track.sendClickLog(TrackeData[action], params);
  }

  // 板书
  private handleBanshu() {
    const {
      lessonId, lessonName, lessonNum,
    } = this.lessonInfo;
    this.clickTrack('PRELESSONS_BANSHU_CLICK', {
      classId: this.currentClass.classId, // 课程id
      lessonId, // 讲次id
      lessonName, // 讲次名称
      lessonNum, // 讲次序号
    });
    this.$emit('click', {
      lessonId, lessonName, classId: this.currentClass.classId, lessonNum,
    });
  }
}
